import {
  Configuration,
  PublicClientApplication,
  RedirectRequest,
} from "@azure/msal-browser";
import { TENANT_ID } from "../../constants/constants";

const configuration: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: new URL("/", window.location.origin).toString(),
    postLogoutRedirectUri: new URL("/", window.location.origin).toString(),
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

const loginRequest: RedirectRequest = {
  scopes: ["User.Read", "User.Read.All"],
};

export const msalInstance = new PublicClientApplication(configuration);

export interface MsalTokens {
  idToken: string;
  graphAccessToken: string;
}

export async function getGraphAccessToken(): Promise<string> {
  await msalInstance.initialize();
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

  if (!account) {
    throw new Error("No signed-in Microsoft account is available.");
  }

  msalInstance.setActiveAccount(account);
  const tokenResponse = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account,
  });

  return tokenResponse.accessToken;
}

export async function completeRedirectSignIn(): Promise<MsalTokens | null> {
  await msalInstance.initialize();
  const response = await msalInstance.handleRedirectPromise();
  const account = response?.account ?? msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

  if (!account) {
    return null;
  }

  msalInstance.setActiveAccount(account);
  const tokenResponse = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account,
  });
  const graphAccessToken = await getGraphAccessToken();
  return {
    idToken: tokenResponse.idToken,
    graphAccessToken,
  };
}

export async function startSignIn(): Promise<void> {
  await msalInstance.initialize();
  await msalInstance.loginRedirect(loginRequest);
}

export async function signOut(): Promise<void> {
  await msalInstance.initialize();
  await msalInstance.logoutRedirect();
}
